import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface Props {
  title: string;
  description?: string;
  crumbs: Crumb[];
}

export default function PageHeader({ title, description, crumbs }: Props) {
  return (
    <div className="bg-background-100 border-b border-background-200/70 pt-16 md:pt-[72px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-8 md:py-12">
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500 mb-4">
          {crumbs.map((c, i) => (
            <span key={`${c.label}-${i}`} className="flex items-center gap-1.5">
              {c.path ? (
                <Link href={c.path} to={c.path} className="hover:text-primary-600 transition-colors">
                  {c.label}
                </Link>
              ) : (
                <span className="text-foreground-700">{c.label}</span>
              )}
              {i < crumbs.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            </span>
          ))}
        </nav>
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{title}</h1>
        {description && <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">{description}</p>}
      </div>
    </div>
  );
}